export default [
  {
    key: 'password',
    placeholder: 'placeholder.password',
    label: 'field.newPassword',
    rules: 'required|min:6',
    type: 'password',
    cols: 12,
  },
  {
    key: 'retypePassword',
    label: 'field.retypeNewPassword',
    placeholder: 'placeholder.password',
    rules: 'required|confirmed:password',
    type: 'password',
    cols: 12,
  },
]
